import {createContext} from "react";
import {UserInterest} from "../../../../../api/grs";

export const ShiftInterestContext = createContext<UserInterest | null>(null);
